import styled, { css } from 'styled-components';
import { rem, rgba } from 'polished';
import variables from '@styles/variables';
import Config from '@config';
import Icon from '@atoms/Icon/Icon';

export const StyledContainer = styled.div<{
  deliveryMode?: 'homeDelivery' | 'pickUpInStore';
  selectedSlot: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: calc(100% + ${rem(10)});
  padding: ${rem(1)} ${rem(6)} ${rem(1)} ${rem(1)};
  z-index: 1;
  gap: ${rem(8)};
  overflow-y: scroll;
  flex-grow: 1;
  min-height: 0;
  padding-right: ${rem(10)};

  @media (hover: hover) and (pointer: fine) {
    @supports selector(::-webkit-scrollbar) {
      padding: ${rem(1)} ${rem(6)} ${rem(1)} ${rem(1)};
      ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: ${rem(4)};
      }

      ::-webkit-scrollbar-thumb {
        border-radius: ${rem(4)};
        background-color: rgba(0, 0, 0, 0.2);
        box-shadow: 0 0 ${rem(1)} rgba(255, 255, 255, 0.5);
      }
    }
  }
`;

export const StyledEmptyContainer = styled.div`
  min-height: ${rem(50)};
  border: ${rem(1)} solid ${variables.colors.mediumGray};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${rem(15)};
  font-family: ${variables.fonts.fontGothamBook};
  width: 100%;
  color: ${variables.colors.darkerGray};
  background-color: ${variables.colors.white};
  cursor: default;
  border-radius: ${rem(4)};
`;

export const StyledDetailsBanner = styled.div<{ isCheckout: boolean; isMobile: boolean }>`
  background-color: ${rgba(variables.colors.highlight, 0.05)};
  color: ${variables.colors.black};
  width: 100%;
  font-size: ${rem(13)};
  display: flex;
  align-items: center;
  margin-top: ${rem(16)};
  padding: ${rem(12)};

  ${(props) =>
    props.isCheckout &&
    !props.isMobile &&
    css`
      justify-content: center;
      text-align: center;
    `}

  ${(props) =>
    props.isCheckout &&
    css`
      margin: 0;

      ${Config.MEDIA.FROM_DESKTOP} {
        flex-basis: 50%;
      }
    `}
`;

export const StyledDetailsBannerEarlySlotIcon = styled(Icon)`
  display: inline-block;
  position: relative;
  top: ${rem(2)};
  margin-right: ${rem(5)};
`;
